import { combineReducers } from 'redux';
import timeclocks from './timeclocks';
import cip from './cip';
import worklogs from './worklogs';
import kiosk from './kiosk';
import availability from './availability';
import schedule from './schedule';
import auth from './auth';
import permissions from './permissions';
import settings from './settings';
import homePage from './homePage';
import supplies from './supplies';
import suppliesArchive from './suppliesArchive';
import currentWorklog from './currentWorklog';
import projectTypes from './projectTypes';
import laborClassifications from './laborClassifications';
import geoLocations from './geoLocations';
import businessDirectory from './businessDirectory';
import people from './people';
import personalProfile from './personalProfile';
import login from './login/loginReducer';
import contractors from './contractors/contractorsPageReducer';
import equipment from './equipment/equipmentPageReducer';
import notes from './notes/notesPageReducer'
import superadmin from './superadmin/superadminReducer';
import workerSchedule from './workerSchedule/workerSchedulePageReducer';
import modals from './modals/modalsPageReducer';
import equipmentScheduleOrder from './equipment/equipmentScheduleOrderPageReducer';
import recentChanges from './recentChanges';


const rootReducer = combineReducers({
  timeclocks,
  cip,
  worklogs,
  availability,
  kiosk,
  schedule,
  auth,
  permissions,
  settings,
  homePage,
  supplies,
  suppliesArchive,
  currentWorklog,
  projectTypes,
  laborClassifications,
  geoLocations,
  businessDirectory,
  people,
  personalProfile,
  login,
  contractors,
  equipment,
  notes,
  superadmin,
  workerSchedule,
  modals,
  equipmentScheduleOrder,
  recentChanges,
});

export default rootReducer;
